interface Props {}
// interface ResponseData {}

const register = (props: Props) => {
	return {};
};
export default register;
